import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import { CKEditor } from "@ckeditor/ckeditor5-react";
// import { Base64UploadAdapter } from "@ckeditor/ckeditor5-upload";
import { IMAGE_MAX_SIZE, IMAGE_TYPE_UPLOAD } from "constants/Constants";
import { apiUploadImage } from "helpers/api/upload-image";
import i18n from "i18n";
import "./styles.scss";

function uploadAdapter(loader) {
  return {
    upload: () => {
      return new Promise(async (resolve, reject) => {
        try {
          const file = await loader.file;
          if (IMAGE_TYPE_UPLOAD.includes(file?.type)) {
            if (file.size > IMAGE_MAX_SIZE) {
              reject(i18n.t("messages.MSG-USP014"));
              return;
            }

            const response = await apiUploadImage(file);
            resolve({
              default: response?.data?.url,
            });
          } else {
            reject(i18n.t("messages.MSG-USP013"));
            return;
          }
        } catch (error) {
          reject("upload faild");
        }
      });
    },
    abort: () => {},
  };
}
function uploadPlugin(editor) {
  editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
    return uploadAdapter(loader);
  };
}

const CKEditorCustom = ({
  title = "",
  labelWidth = "150px",
  onChange,
  value = "",
  showToolbar = true,
  placeholder,
  error,
  onError = () => {},
}) => {
  return (
    <div
      className={`ckeditor-container ckeditor-toolbar-${
        showToolbar ? "show" : "hidden"
      }`}
    >
      {title && (
        <div
          className="ckeditor-title"
          style={{
            width: labelWidth,
          }}
        >
          {title}
        </div>
      )}
      <div
        className={`ckeditor-input-container ${error ? "border-error" : ""}`}
      >
        <CKEditor
          config={{
            height: "500px",
            placeholder,
            ui: {
              poweredBy: {
                label: null,
                position: "inside",
              },
            },
            fontFamily: {
              options: [
                "default",
                "Arial, Helvetica, sans-serif",
                "Courier New, Courier, monospace",
                "Georgia, serif",
                "Lucida Sans Unicode, Lucida Grande, sans-serif",
                "Tahoma, Geneva, sans-serif",
                "Times New Roman, Times, serif",
                "Trebuchet MS, Helvetica, sans-serif",
                "Verdana, Geneva, sans-serif",
              ],
              supportAllValues: true,
            },
            toolbar: {
              items: showToolbar
                ? [
                    "fontFamily",
                    "bold",
                    "italic",
                    "underline",
                    "|",
                    "bulletedList",
                    "numberedList",
                    "outdent",
                    "indent",
                    "|",
                    "alignment",
                    "fontColor",
                    "|",
                    "imageUpload",
                    "link",
                  ]
                : [],
              shouldNotGroupWhenFull: false,
            },
            // plugins: [WordCount],
            // wordCount: {
            //   onUpdate: (stats) => {
            //     // Prints the current content statistics.
            //     console.log(
            //       `Characters: ${stats.characters}\nWords: ${stats.words}`
            //     );
            //   },
            // },
            extraPlugins: [uploadPlugin],
          }}
          onReady={(editor) => {
            console.log("Editor is ready to use!", editor);

            // Insert the toolbar before the editable area.
            editor.ui
              .getEditableElement()
              .parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
              );
          }}
          onError={(error, { willEditorRestart }) => {
            onError(error);
            // If the editor is restarted, the toolbar element will be created once again.
            // The `onReady` callback will be called again and the new toolbar will be added.
            // This is why you need to remove the older toolbar.
            if (willEditorRestart) {
              this.editor.ui.view.toolbar.element.remove();
            }
          }}
          onChange={onChange}
          editor={DecoupledEditor}
          data={value}
          // config={ /* the editor configuration */ }
        />
        {error ? <span className="error">{error}</span> : null}
      </div>
    </div>
  );
};

export default CKEditorCustom;
